import AmexGDAB2BHero from './AmexGDAB2BHero';

export default AmexGDAB2BHero;
